export default __webpack_public_path__ + "static/media/profile-holder.1ec129b1.svg";